import React from "react";
import { Route, Redirect } from "react-router-dom";

const LabtopRoute = ({ component: Component, isAuthenticated, routes, ...rest }) => {
  return <Route
    {...rest}
    render={props => {
      return (isAuthenticated === 'success'
        ? <Component {...props} routes={routes || []} isAuthenticated={isAuthenticated}/>
        : <Redirect
          to={{
            pathname: "/adminLogin",
            state: { from: props.location }
          }}
        />)
    }
    }
  />
}

const PublicRoute = route => (
  <Route
      path={route.path}
      exact={route.exact || false}
      render={props => (
          // pass the sub-routes down to keep nesting
          <route.component {...props} routes={route.routes || []} />
      )}
  />
);

const MobileRoute = ({ component: Component, isAuthenticated, routes, ...rest }) => {
  return <Route
    {...rest}
    render={props => {
      return (isAuthenticated === 'success'
        ? <Component {...props} routes={routes || []} isAuthenticated={isAuthenticated}/>
        : <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location }
          }}
        />)
    }
    }
  />
}

export {
  LabtopRoute,
  PublicRoute,
  MobileRoute
};
